

import React from 'react';
import './index.scss';

function ComTitle({
    title
}) {
    return (
        <div className='com-title'>
            <img alt='' src='https://img11.360buyimg.com/imagetools/jfs/t1/161987/5/14650/2442/605b054aE5918e2e5/55b20a6d00a41207.png' />
            <div>{title}</div>
        </div>
    )
}

export default React.memo(ComTitle);